export const conditionOptions = [
  {
    value: 0,
    title: 'Välj skick',
  },
  {
    value: 1,
    title: 'Ny',
  },
  {
    value: 2,
    title: 'Använd - Nyskick',
  },
  {
    value: 3,
    title: 'Använd - Bra skick',
  },
  {
    value: 4,
    title: 'Använd - Ok skick',
  },
  {
    value: 5,
    title: 'Använd - Sliten',
  },
];
